module.exports = __webpack_public_path__ + "static/img/AI-3.f367dcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-3.jpg
// module id = BMej
// module chunks = 36